import type { JiraSpaRoute, RouterContext } from '@atlassian/react-resource-router';
import type { RouteName } from '@jira/platform__routing-route-name-types/src/RouteName.tsx';
import { MENU_ID_ITAM } from '../../../../constants.tsx';
import type { SelectedPath } from '../../../../types.tsx';

const routes = new Set<RouteName>([
	'itam',
	'itam-ai-insights-preview',
	'itam-settings',
	'itam-ham-overview',
	'itam-ham-hardware',
	'itam-ham-models',
	'itam-ham-stockrooms',
	'itam-ham-work',
	'itam-ham-dashboard',
]);

function convert(routeContext: RouterContext<JiraSpaRoute>): SelectedPath {
	const routeName: RouteName = routeContext.route.name;
	const path: string[] = [];
	return convertRouteToPath({ routeName, path });
}

function convertNew(args: { routeName: RouteName }): SelectedPath {
	const { routeName } = args;
	const path: string[] = [];
	return convertRouteToPath({ routeName, path });
}

function convertRouteToPath(args: { routeName: RouteName; path: string[] }): SelectedPath {
	const { routeName, path } = args;

	switch (routeName) {
		case 'itam':
		case 'itam-ai-insights-preview':
		case 'itam-settings':
		case 'itam-ham-overview':
		case 'itam-ham-hardware':
		case 'itam-ham-models':
		case 'itam-ham-stockrooms':
		case 'itam-ham-work':
		case 'itam-ham-dashboard':
			path.push(MENU_ID_ITAM);
			break;
		default:
	}

	return path;
}

export const itamConverter: {
	routes: Set<RouteName>;
	convert: typeof convert;
	convertNew: typeof convertNew;
} = { routes, convert, convertNew };
